import { render, staticRenderFns } from "./DiscoveredAssetsPage.vue?vue&type=template&id=2708b7f8&scoped=true"
import script from "./DiscoveredAssetsPage.vue?vue&type=script&lang=js"
export * from "./DiscoveredAssetsPage.vue?vue&type=script&lang=js"
import style0 from "./DiscoveredAssetsPage.vue?vue&type=style&index=0&id=2708b7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708b7f8",
  null
  
)

export default component.exports